var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1015 8.30143C12.4927 7.91089 12.4928 7.27711 12.1018 6.88641L10.1147 4.90076C9.72435 4.51065 9.09173 4.51056 8.70123 4.90055L0.293351 13.2976C0.105535 13.4851 0 13.7397 0 14.0051V15.99C0 16.5423 0.447715 16.99 1 16.99H2.9857C3.25065 16.99 3.50477 16.8849 3.69226 16.6977L12.1015 8.30143ZM12.898 0.707107C13.2885 0.316582 13.9217 0.316582 14.3122 0.707106L16.2975 2.69235C16.688 3.08287 16.688 3.71604 16.2975 4.10656L15.1171 5.28693C14.7266 5.67746 14.0934 5.67746 13.7029 5.28693L11.7177 3.30169C11.3271 2.91116 11.3271 2.278 11.7177 1.88747L12.898 0.707107Z",
    fill: "var(--color-blue)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.cee13bfa.svg";
export { ForwardRef as ReactComponent };